import { render, staticRenderFns } from "./inventoryDetails.vue?vue&type=template&id=607bda1f&scoped=true&"
import script from "./inventoryDetails.vue?vue&type=script&lang=js&"
export * from "./inventoryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607bda1f",
  null
  
)

export default component.exports